import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { AccountsSVGIcons, ConsumerSVGIcons } from './product-icons-helper';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';

type SvgMask = 'confetti';
@Component({
  selector: 'dx-product-image',
  templateUrl: './product-image.component.html',
  styleUrls: ['./product-image.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SharedUiLibraryModule]
})
export class ProductImageComponent {
  @Input({ required: true }) product: string;
  @Input() icon!: string;
  @Input({ required: true }) flowType: string;
  @Input() size = '120px';
  @HostBinding('style.width') get width() {
    return this.mask? `calc(${this.size} + ${this.size}/3)` : this.size;
  }
  @HostBinding('style.height') get height() {
    return this.size;
  }

  /**
   * This is an overlay svg on top of the product icon
   * Available options: 'confetti'
   * It can be used to add a confetti, a "New" or "Special Offer" badge, etc.
   */
  @Input() mask: SvgMask;

  public setIconClass() {
    if (!!this.icon?.length) return this.icon;

    if (!this.product || !this.flowType) {
      return 'us-currency';
    }
    return this.flowType.toLowerCase() === 'ola'
      ? ConsumerSVGIcons(this.product.toLowerCase())
      : AccountsSVGIcons(this.product.toLowerCase());
  }

  public setMaskClass() {
    switch (this.mask) {
      case 'confetti':
        return 'confetti-mask';
      default:
        return undefined;
    }
  }
}